import Lenis from 'lenis';

export default class SmoothScroll {
  constructor() {
    if (window.__lenis) return window.__lenis;

    this.lenis = new Lenis({
      smooth: true,
      lerp: 0.08,
      wheelMultiplier: 1,
      touchMultiplier: 1,
      normalizeWheel: true
    });

    this.raf = this.raf.bind(this);
    requestAnimationFrame(this.raf);

    window.__lenis = this;
  }

  raf(time) {
    this.lenis.raf(time);
    requestAnimationFrame(this.raf);
  }

  stop() {
    this.lenis.stop();
  }

  start() {
    this.lenis.start();
  }

  scrollTo(target, options) {
    this.lenis.scrollTo(target, options);
  }
}
